export const playAudio = (fileSource: string) => {
  const audio = new Audio(fileSource);
  audio.play();
};
